var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStripesFull = function SvgStripesFull(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 4159.409 2340.093",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M479.168 2157.526l201.228-201.228",
    stroke: "#fff",
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 140,
    strokeLinecap: "round",
    fillOpacity: 1,
    strokeOpacity: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M643.407 2390.68l102.001-102",
    stroke: "#fff",
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 140,
    strokeLinecap: "round",
    fillOpacity: 1,
    strokeOpacity: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M118.353 2120.948l98.07-98.07",
    stroke: "#fff",
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: 140,
    strokeLinecap: "round",
    strokeOpacity: 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-41.453 1883.36l454.662-454.662",
    stroke: "#fff",
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: 140,
    strokeLinecap: "round",
    strokeOpacity: 1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M214.52 1229.994l260.745-260.748",
    stroke: "#fff",
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: 140,
    strokeLinecap: "round",
    strokeOpacity: 1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M214.52 1229.993l260.747-260.747",
    stroke: "#fff",
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: 140,
    strokeLinecap: "round",
    strokeOpacity: 1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3700.905 525.362l201.23-201.228",
    stroke: "#fff",
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 140,
    strokeLinecap: "round",
    fillOpacity: 1,
    strokeOpacity: 1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4065.963 1352.486l98.07-98.07",
    stroke: "#fff",
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 140,
    strokeLinecap: "round",
    fillOpacity: 1,
    strokeOpacity: 1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3906.158 1114.9l454.66-454.663",
    stroke: "#fff",
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 140,
    strokeLinecap: "round",
    fillOpacity: 1,
    strokeOpacity: 1
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4162.13 461.533l260.745-260.748",
    stroke: "#fff",
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 140,
    strokeLinecap: "round",
    fillOpacity: 1,
    strokeOpacity: 1
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3555.32 1863.13l315.66-315.66",
    stroke: "#fff",
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 140,
    strokeLinecap: "round",
    fillOpacity: 1,
    strokeOpacity: 1
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M3830.688 792.974l102-102",
    stroke: "#fff",
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 140,
    strokeLinecap: "round",
    fillOpacity: 1,
    strokeOpacity: 1
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M3256.921 2161.528l98.07-98.07",
    stroke: "#fff",
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 140,
    strokeLinecap: "round",
    fillOpacity: 1,
    strokeOpacity: 1
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M2746.28 2672.171l315.66-315.66",
    stroke: "#fff",
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 140,
    strokeLinecap: "round",
    fillOpacity: 1,
    strokeOpacity: 1
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M3604.034 224.842l315.66-315.66",
    stroke: "#fff",
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: 140,
    strokeLinecap: "round",
    strokeOpacity: 1
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M167.242 482.486l98.07-98.07",
    stroke: "#fff",
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 140,
    strokeLinecap: "round",
    fillOpacity: 1,
    strokeOpacity: 1
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M7.437 244.899l454.66-454.663",
    stroke: "#fff",
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 140,
    strokeLinecap: "round",
    fillOpacity: 1,
    strokeOpacity: 1
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M-343.4 993.129l315.66-315.66",
    stroke: "#fff",
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 140,
    strokeLinecap: "round",
    fillOpacity: 1,
    strokeOpacity: 1
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M3652.192 2163.65l201.23-201.23",
    stroke: "#fff",
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 140,
    strokeLinecap: "round",
    fillOpacity: 1,
    strokeOpacity: 1
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M4113.417 2099.82l260.745-260.748",
    stroke: "#fff",
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 140,
    strokeLinecap: "round",
    fillOpacity: 1,
    strokeOpacity: 1
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M4113.418 2099.818l260.747-260.746",
    stroke: "#fff",
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 140,
    strokeLinecap: "round",
    fillOpacity: 1,
    strokeOpacity: 1
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M3781.975 2431.262l102.001-102.002",
    stroke: "#fff",
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 140,
    strokeLinecap: "round",
    fillOpacity: 1,
    strokeOpacity: 1
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M527.88 519.24l201.23-201.23",
    stroke: "#fff",
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 140,
    strokeLinecap: "round",
    fillOpacity: 1,
    strokeOpacity: 1
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M-116.922 1561.435l102.001-102",
    stroke: "#fff",
    fill: "#fff",
    fillRule: "evenodd",
    strokeWidth: 140,
    strokeLinecap: "round",
    fillOpacity: 1,
    strokeOpacity: 1
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M465.466 184.261l315.66-315.66",
    stroke: "#fff",
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: 140,
    strokeLinecap: "round",
    strokeOpacity: 1
  })));
};
export default SvgStripesFull;